import { render, staticRenderFns } from "./headMsg.vue?vue&type=template&id=2f6fbf24&scoped=true&"
import script from "./headMsg.vue?vue&type=script&lang=js&"
export * from "./headMsg.vue?vue&type=script&lang=js&"
import style0 from "./headMsg.vue?vue&type=style&index=0&id=2f6fbf24&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6fbf24",
  null
  
)

export default component.exports